import { paths } from '@/config/paths';
import { useAuthStore } from '@/lib/stores';
import { Navigate } from 'react-router-dom';

export const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const { user } = useAuthStore();

  // Check if user exists and has admin role
  if (!user || user.role !== 'admin') {
    // Redirect non-admin users to dashboard
    return <Navigate to={paths.app.dashboard.getHref()} replace />;
  }

  return children;
};
